import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from "@emotion/css";
import $ from "jquery";
import keycode from "keycode";
import { parse, stringify, stringifyUrl } from "query-string";
import { useEffect, useRef, useState } from "react";
import { body, getCountryProperties, isNotUndefined, isUndefined, trackSearchType, windowOnLoadOrImmediate } from "../FunctionsCore";
import { addToRenderableData, renderIdentifierGeneric } from "../RenderIdentifier";
import { contactProfilesCompanyFragmentParameterName, contactProfilesFullNameFragmentParameterName, contactProfilesJobTitleFragmentParameterName, getPageNumberFragmentParameterName, getSearchFragmentParameterName, singlePageSearchSharedClassCombiner, singlePageSearchSharedStyles, stringToTab } from "./SinglePageSearchShared";
import { TabAllTabContentsComponent } from "./TabAll";
import { TabCompanyProfilesTabContentsNotForAllTabComponent } from "./TabCompanyProfiles";
import { TabContactProfilesTabContentsComponent } from "./TabContactProfiles";
import { TabDAndBMarketplaceTabContentsNotForAllTabComponent } from "./TabDAndBMarketplace";
import { TabSiteContentContentsNotForAllTabComponent } from "./TabSiteContent";
import { TabSiteContentAddSearchContentsNotForAllTabComponent } from "./TabSiteContentAddSearch";
// Adapted from https://github.com/molefrog/wouter#customizing-the-location-hook
const parseWindowLocation = () => {
    const windowLocation = window.location;
    const parsedQuery = parse(windowLocation.hash);
    const fragmentParametersFiltered = {};
    for (const [key, value] of window.Object.entries(parsedQuery)) {
        if (typeof value === "string") {
            fragmentParametersFiltered[key] = value;
        }
    }
    return {
        "fragmentParameters": fragmentParametersFiltered,
        "navigationOnlyFragmentParameters": {},
        "urlWithoutFragment": windowLocation.pathname,
    };
};
const tabKey = "tab";
const useFragmentAndUrlStateHook = () => {
    const [fragmentAndUrlState, setFragmentAndUrlState] = useState(Object.assign(Object.assign({}, parseWindowLocation()), { "forceReload": false, "navigationOnlyFragmentParameters": {} }));
    useEffect(() => {
        const listener = () => {
            setFragmentAndUrlState((fragmentAndUrlStateTwo) => (Object.assign(Object.assign({}, parseWindowLocation()), { "forceReload": fragmentAndUrlStateTwo.forceReload, "navigationOnlyFragmentParameters": fragmentAndUrlStateTwo.navigationOnlyFragmentParameters })));
        };
        window.addEventListener("hashchange", listener);
        return () => window.removeEventListener("hashchange", listener);
    }, []);
    return [
        fragmentAndUrlState,
        (transformFragmentAndUrlState) => {
            setFragmentAndUrlState((fragmentAndUrlStateTwo) => {
                const transformedFragmentAndUrlState = transformFragmentAndUrlState(fragmentAndUrlStateTwo);
                const filteredFragmentAndNavigationOnlyFragmentParameters = {};
                const filteredFragmentParameters = {};
                for (const [key, value] of window.Object.entries(transformedFragmentAndUrlState.fragmentParameters).filter(([_, st]) => st.length > 0)) {
                    filteredFragmentAndNavigationOnlyFragmentParameters[key] = value;
                    filteredFragmentParameters[key] = value;
                }
                for (const [key, value] of window.Object.entries(transformedFragmentAndUrlState.navigationOnlyFragmentParameters).filter(([_, st]) => st.length > 0)) {
                    filteredFragmentAndNavigationOnlyFragmentParameters[key] = value;
                }
                if (transformedFragmentAndUrlState.forceReload ||
                    transformedFragmentAndUrlState.urlWithoutFragment !== fragmentAndUrlStateTwo.urlWithoutFragment) {
                    const filteredFragmentAndNavigationOnlyFragmentParametersTab = filteredFragmentAndNavigationOnlyFragmentParameters[tabKey];
                    const filteredFilteredFragmentAndNavigationOnlyFragmentParameters = {};
                    if (isNotUndefined(filteredFragmentAndNavigationOnlyFragmentParametersTab)) {
                        const tab = stringToTab(filteredFragmentAndNavigationOnlyFragmentParametersTab);
                        const allowedFragmentParameterNames = [tabKey, getPageNumberFragmentParameterName(tab)];
                        if (tab === "Contact Directory") {
                            allowedFragmentParameterNames.push(contactProfilesCompanyFragmentParameterName, contactProfilesFullNameFragmentParameterName, contactProfilesJobTitleFragmentParameterName);
                        }
                        else {
                            allowedFragmentParameterNames.push(getSearchFragmentParameterName(tab));
                        }
                        for (const [key, value] of window.Object.entries(filteredFragmentAndNavigationOnlyFragmentParameters).filter(([st, _]) => allowedFragmentParameterNames.includes(st))) {
                            filteredFilteredFragmentAndNavigationOnlyFragmentParameters[key] = value;
                        }
                    }
                    else {
                        for (const [key, value] of window.Object.entries(filteredFragmentAndNavigationOnlyFragmentParameters)) {
                            filteredFilteredFragmentAndNavigationOnlyFragmentParameters[key] = value;
                        }
                    }
                    window.location.href = stringifyUrl({
                        "fragmentIdentifier": stringify(filteredFilteredFragmentAndNavigationOnlyFragmentParameters),
                        "url": transformedFragmentAndUrlState.urlWithoutFragment,
                    }, { "encode": false });
                    if (transformedFragmentAndUrlState.forceReload) {
                        window.location.reload();
                    }
                }
                else {
                    window.location.hash = stringify(filteredFragmentParameters);
                }
                return transformedFragmentAndUrlState;
            });
        },
    ];
};
const getTabTitle = (tab, singlePageSearchData) => {
    let localizedTabTitle;
    switch (tab) {
        case "All": {
            localizedTabTitle = singlePageSearchData.allLocalized;
            break;
        }
        case "Business Directory": {
            localizedTabTitle = singlePageSearchData.companyprofilesLocalized;
            break;
        }
        case "Contact Directory": {
            localizedTabTitle = singlePageSearchData.contactprofilesLocalized;
            break;
        }
        case "Marketplace": {
            localizedTabTitle = singlePageSearchData.dandbmarketplaceLocalized;
            break;
        }
        case "Site Content": {
            localizedTabTitle = singlePageSearchData.sitecontentLocalized;
            break;
        }
    }
    return localizedTabTitle !== null && localizedTabTitle !== void 0 ? localizedTabTitle : tab;
};
const SinglePageSearchComponent = (props) => {
    var _a, _b;
    const { env, isSearchOverlay, isSearchOverlayOpen, resourcePath, setIsSearchOverlayOpen, singlePageSearchData, token, } = props;
    const { businessDirectoryPath, currentPageAbsoluteParentTwoPagePath, currentPagePath, errorHandlerPath, isEuBd, siteSearchResultsPath, siteSearchResultsPathRewritten, useAddSearch } = singlePageSearchData;
    const { countryCode, siteNode, } = getCountryProperties(currentPageAbsoluteParentTwoPagePath);
    const isUnitedStates = siteNode === "dnb-mod" || siteNode === "dnb-us";
    const isSearchOverlayAndNotUnitedStates = !isUnitedStates && isSearchOverlay;
    const tabOrder = isSearchOverlayAndNotUnitedStates && !isEuBd
        ? ["Site Content"]
        : (isEuBd
            ? ["All", "Business Directory", "Site Content"]
            : ["Site Content", "Business Directory", "Contact Directory", "Marketplace"]);
    const tabTabContentsComponentArray = isSearchOverlayAndNotUnitedStates && !isEuBd
        ? [
            { "tab": "All", "tabContentsComponent": TabAllTabContentsComponent },
            {
                "tab": "Site Content",
                "tabContentsComponent": TabSiteContentContentsNotForAllTabComponent,
            },
        ]
        : (isEuBd
            ? [
                { "tab": "All", "tabContentsComponent": TabAllTabContentsComponent },
                {
                    "tab": "Business Directory",
                    "tabContentsComponent": TabCompanyProfilesTabContentsNotForAllTabComponent,
                },
                { "tab": "Site Content", "tabContentsComponent": TabSiteContentContentsNotForAllTabComponent },
            ]
            : [
                {
                    "tab": "Business Directory",
                    "tabContentsComponent": TabCompanyProfilesTabContentsNotForAllTabComponent,
                },
                { "tab": "Contact Directory", "tabContentsComponent": TabContactProfilesTabContentsComponent },
                {
                    "tab": "Marketplace",
                    "tabContentsComponent": TabDAndBMarketplaceTabContentsNotForAllTabComponent,
                },
                { "tab": "Site Content", "tabContentsComponent": useAddSearch ? TabSiteContentAddSearchContentsNotForAllTabComponent : TabSiteContentContentsNotForAllTabComponent },
            ]);
    const [fragmentAndUrlState, setFragmentAndUrlState] = useFragmentAndUrlStateHook();
    const tabsWrapperReference = useRef(null);
    const isBusinessDirectoryLandingPage = currentPagePath.endsWith(businessDirectoryPath);
    const isContactDirectoryLandingPage = currentPagePath.endsWith("/home/contact-directory");
    const isErrorPage = currentPagePath.includes(errorHandlerPath);
    const isSiteSearchResultsPage = currentPagePath.endsWith(siteSearchResultsPath);
    const isBusinessDirectoryLandingPageAndNotSearchOverlay = isBusinessDirectoryLandingPage && !isSearchOverlay;
    const isContactDirectoryLandingPageAndNotSearchOverlay = isContactDirectoryLandingPage && !isSearchOverlay;
    const isErrorPageAndNotSearchOverlay = isErrorPage && !isSearchOverlay;
    const isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage = isBusinessDirectoryLandingPage || isContactDirectoryLandingPage || isErrorPage;
    const useFragmentAndUrlStateTriggerNavigation = (key, defaultValue, outerTriggerNavigation) => {
        const setValue = (newValue, triggerNavigation) => setFragmentAndUrlState((fragmentAndUrlStateTwo) => ({
            "forceReload": isSearchOverlay && isSiteSearchResultsPage && triggerNavigation && key !== tabKey,
            "fragmentParameters": isSearchOverlay
                ? fragmentAndUrlStateTwo.fragmentParameters
                : Object.assign(Object.assign({}, fragmentAndUrlStateTwo.fragmentParameters), { [key]: newValue }),
            "navigationOnlyFragmentParameters": isSearchOverlay
                ? Object.assign(Object.assign({}, fragmentAndUrlStateTwo.navigationOnlyFragmentParameters), { [key]: newValue }) : fragmentAndUrlStateTwo.navigationOnlyFragmentParameters,
            "urlWithoutFragment": triggerNavigation &&
                key !== tabKey &&
                (isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage || isSearchOverlay)
                ? siteSearchResultsPathRewritten
                : fragmentAndUrlStateTwo.urlWithoutFragment,
        }));
        let valueToUse;
        if (isSearchOverlay) {
            const valueFromNavigationOnlyFragmentParameters = fragmentAndUrlState.navigationOnlyFragmentParameters[key];
            valueToUse = isNotUndefined(valueFromNavigationOnlyFragmentParameters)
                ? valueFromNavigationOnlyFragmentParameters
                : defaultValue;
        }
        else {
            const valueFromFragmentParameters = fragmentAndUrlState.fragmentParameters[key];
            if (isUndefined(valueFromFragmentParameters)) {
                setValue(defaultValue, false);
                valueToUse = defaultValue;
            }
            else {
                valueToUse = valueFromFragmentParameters;
            }
        }
        return [valueToUse, (newValue) => setValue(newValue, outerTriggerNavigation)];
    };
    const useFragmentAndUrlState = (key, defaultValue) => useFragmentAndUrlStateTriggerNavigation(key, defaultValue, true);
    const manuallyTriggerNavigation = () => setFragmentAndUrlState((fragmentAndUrlStateTwo) => ({
        "forceReload": isSearchOverlay && isSiteSearchResultsPage,
        "fragmentParameters": fragmentAndUrlStateTwo.fragmentParameters,
        "navigationOnlyFragmentParameters": fragmentAndUrlStateTwo.navigationOnlyFragmentParameters,
        "urlWithoutFragment": isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage || isSearchOverlay
            ? siteSearchResultsPathRewritten
            : fragmentAndUrlStateTwo.urlWithoutFragment,
    }));
    let defaultActiveTab;
    if (isSearchOverlayAndNotUnitedStates && !isEuBd) {
        defaultActiveTab = "Site Content";
    }
    else if (isBusinessDirectoryLandingPage) {
        defaultActiveTab = "Business Directory";
    }
    else if (isContactDirectoryLandingPage) {
        defaultActiveTab = "Contact Directory";
    }
    else {
        defaultActiveTab = "Site Content";
    }
    const [tabFromFragmentAndUrlState, setTabFromFragmentAndUrlState] = useFragmentAndUrlState(tabKey, defaultActiveTab);
    const [activeTab, setActiveTab] = [
        stringToTab(tabFromFragmentAndUrlState),
        (tab) => setTabFromFragmentAndUrlState(tab),
    ];
    const [addLazyloadClass, setAddLazyloadClass] = useState(false);
    const [searchInput, setSearchInput] = useState("");
    useEffect(() => {
        const eventListener = (ke) => {
            if (isNotUndefined(setIsSearchOverlayOpen) && ke.which === keycode.codes.esc) {
                setIsSearchOverlayOpen(false);
            }
        };
        window.document.addEventListener("keydown", eventListener);
        return () => {
            window.document.removeEventListener("keydown", eventListener);
        };
    }, [setIsSearchOverlayOpen]);
    useEffect(() => {
        $(body).toggleClass(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "bodyOverlay"), isSearchOverlay && isSearchOverlayOpen);
        if (isSearchOverlay && isSearchOverlayOpen) {
            setAddLazyloadClass(true);
        }
    }, [isSearchOverlay, isSearchOverlayOpen]);
    useEffect(() => {
        if (isSearchOverlay) {
            windowOnLoadOrImmediate($(window), () => setAddLazyloadClass(true));
        }
    }, [isSearchOverlay]);
    const [companyProfilesSearchValue, setCompanyProfilesSearchValue] = useFragmentAndUrlState(getSearchFragmentParameterName("Business Directory"), "");
    return (_jsxs("div", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "outerWrapper"), singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, `isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage-${isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage}`), singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, `isBusinessDirectoryLandingPageAndNotSearchOverlay-${isBusinessDirectoryLandingPageAndNotSearchOverlay}`), singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, `isErrorPageAndNotSearchOverlay-${isErrorPageAndNotSearchOverlay}`), singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, `isSearchOverlay-${isSearchOverlay}`), addLazyloadClass && !isUnitedStates ? "lazyload" : "trans-overlay") }, { children: [isUnitedStates ? (_jsx(_Fragment, {})) : (_jsxs("div", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "heading"), singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, `isContactDirectoryLandingPageAndNotSearchOverlay-${isContactDirectoryLandingPageAndNotSearchOverlay}`)) }, { children: [isContactDirectoryLandingPageAndNotSearchOverlay ? (_jsx(_Fragment, {})) : (_jsxs("div", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "headingImageAndTextWrapper")) }, { children: [_jsx("div", { className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "headingImage"), singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, `isBusinessDirectoryLandingPage-${isBusinessDirectoryLandingPage}`)) }), _jsx("div", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "headingText")) }, { children: isBusinessDirectoryLandingPageAndNotSearchOverlay
                                    ? (_a = singlePageSearchData.dandbBusinessDirectoryLocalized) !== null && _a !== void 0 ? _a : "D&B Business Directory"
                                    : (_b = singlePageSearchData.searchthedunandbradstreetcloudLocalized) !== null && _b !== void 0 ? _b : "Search the Dun & Bradstreet Cloud" }))] }))), isSearchOverlay ? (_jsx("button", { "aria-label": "Close", className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "headingSearchOverlayCloseButton")), onClick: () => {
                            if (isNotUndefined(setIsSearchOverlayOpen)) {
                                setIsSearchOverlayOpen(false);
                            }
                        }, type: "button" })) : (_jsx(_Fragment, {}))] }))), _jsx("div", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "wrapper")) }, { children: _jsx("div", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "allSearchTypes")) }, { children: _jsx("div", Object.assign({ className: "row" }, { children: _jsx("div", Object.assign({ className: cx("col-xs-12", "col-md-12", singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "tabsWrapper")), ref: tabsWrapperReference }, { children: tabOrder.map((ta, nu) => (_jsx("button", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "tab"), ta === activeTab
                                    ? singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "activeTab")
                                    : void 0), onClick: () => {
                                    setActiveTab(ta);
                                    trackSearchType(ta);
                                }, type: "button" }, { children: getTabTitle(ta, singlePageSearchData) }), nu))) })) })) })) })), tabTabContentsComponentArray.map((va, nu) => {
                const isActiveTab = va.tab === activeTab;
                return (_jsx("div", Object.assign({ className: cx(singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, "tabContentsComponentWrapper"), singlePageSearchSharedClassCombiner(singlePageSearchSharedStyles, `isActiveTab-${isActiveTab}`)) }, { children: _jsx(va.tabContentsComponent, { activeTab: activeTab, companyProfilesSearchValue: companyProfilesSearchValue, countryCode: countryCode, env: env, isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage: isBusinessDirectoryLandingPageOrContactDirectoryLandingPageOrErrorPage, isEuBd: isEuBd, isSearchOverlay: isSearchOverlay, isSearchOverlayAndNotUnitedStates: isSearchOverlayAndNotUnitedStates, isSearchOverlayOpen: isSearchOverlayOpen, isSiteSearchResultsPage: isSiteSearchResultsPage, manuallyTriggerNavigation: manuallyTriggerNavigation, resourcePath: resourcePath, searchInput: searchInput, setActiveTab: setActiveTab, setCompanyProfilesSearchValue: setCompanyProfilesSearchValue, setIsSearchOverlayOpen: setIsSearchOverlayOpen, setSearchInput: setSearchInput, singlePageSearchData: singlePageSearchData, tabAllSearchValue: void 0, token: token, useFragmentAndUrlState: useFragmentAndUrlState, useFragmentAndUrlStateTriggerNavigation: useFragmentAndUrlStateTriggerNavigation }) }), nu));
            })] })));
};
const singlePageSearch = (renderableData) => renderIdentifierGeneric(SinglePageSearchComponent, addToRenderableData(renderableData, {
    "isSearchOverlay": false,
    "isSearchOverlayOpen": false,
    "setIsSearchOverlayOpen": void 0,
}));
export { singlePageSearch, SinglePageSearchComponent };
